import { render, staticRenderFns } from "./VerifyIdentity.vue?vue&type=template&id=2e8cfd29"
import script from "./VerifyIdentity.vue?vue&type=script&lang=ts"
export * from "./VerifyIdentity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports